import type { WbsClient } from '@bldsoft/cappie/api/wbs'
import type { API } from '@setplex/tria-api'

import { payload } from '@bldsoft/cappie/rest'
import * as v from 'valibot'
import { MotnSearchResultSchema } from './motn-search.schema'
import { MotnTvShowSchema } from './motn-tv-show.format'
import { MotnVodSchema } from './motn-vod.format'

export function use(
  client: WbsClient,
  externalContent: API['externalContent'],
  _api: API
): void {
  // GET /v3/movienight/{service}/series
  externalContent.getMovieNightSeriesFx.use(async ({ service }) => {
    const json = await payload(client.get.api.v3.movienight(service).series())
    return v.parse(v.array(MotnTvShowSchema), json)
  })

  // GET /v3/movienight/{service}/movie
  externalContent.getMovieNightMoviesFx.use(async ({ service }) => {
    const json = await payload(client.get.api.v3.movienight(service).movie())
    return v.parse(v.array(MotnVodSchema), json)
  })

  // GET /v3/movienight/search
  externalContent.getMovieNightSearchFx.use(async ({ q, signal }) => {
    const json = await payload(
      client.get.api.v3.movienight.search({ query: { q }, signal })
    )
    return v.parse(MotnSearchResultSchema, json)
  })
}
